/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ workspace: NonNullable<unknown> }} Invite_TitleInputs */

const en_invite_title = /** @type {(inputs: Invite_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Join ${i?.workspace}`)
};

/**
* | output |
* | --- |
* | "Join {workspace}" |
*
* @param {Invite_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const invite_title = /** @type {((inputs: Invite_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_TitleInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_invite_title(inputs)
});